export default __webpack_public_path__ + "static/radler-image-18cfd8a7ae01e18e80db63a271a5d652.png";